import Chip from '@mui/material/Chip'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const StyledChip = styled(Chip)`
  background-color: ${colors.white};
  height: auto;
  line-height: 26px;
  border-color: ${colors.black};
`

export const ChipWrapper = styled('div')`
  overflow: auto;
`

export const ChipListWrapper = styled('div')`
  display: flex;
  gap: 7px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: 10px;
  align-items: center;
`
